



import { EMPTY_GUID, constructUrl, encode } from "@utils/helpers";
import { genericService } from "shared/GenericService";

const InitActionCreator = ({ baseUrl, method }) => {
    return ({ type, endPoint, data, responseType, params, meta }) => ({
        type,
        request: {
            url: baseUrl + endPoint,
            method,
            data,
            responseType,
        },
        meta,
        params,
    });
};
const createPostAction = InitActionCreator({ baseUrl: "api/comment/", method: "POST" }); // api actions type post
const createPostMapAction = InitActionCreator({ baseUrl: "api/map/", method: "POST" }); // api actions type post
// api actions type post
export const createComment = (props) => {
    const mentionedUsers = [...new Set(props?.mentions)]?.reduce((result, string, index) => {

        result[index] = string.id;
        return result;
    }, {});
    return genericService({
        ...props, action: createPostAction({
            type: 'CREATE_COMMENT', endPoint: "create",
            data: {
                discussionId: props?.discussionId,
                description: encode(props?.description),
                mentionedUsers: mentionedUsers,
                cjmId: props?.cjmIdStr,
                personaId: props?.personaIdStr,
                ownerId: props?.ownerId,
            }
        })
    });
}
export const updateComment = (props) => {
    const mentionedUsers = [...new Set(props?.mentions)].reduce((result, string, index) => {
        result[index] = string;
        return result;
    }, {});
    return genericService({
        ...props, action: createPostAction({
            type: 'UPDATE_COMMENT', endPoint: "updateCommentDescription",
            data: {
                discussionId: props?.discussionId,
                newDescription: encode(props?.newDescription),
                mentionedUsers: mentionedUsers,
                cjmId: props?.cjmId,
                personaId: props?.personaId,
                ownerId: props?.ownerId || EMPTY_GUID,
                commentId: props?.commentId
            }
        })
    });
};

export const deleteComment = (props) => genericService({
    ...props, action: createPostAction({
        type: 'DELETE_COMMENT', endPoint: "deleteComment",
        data: {

            discussionId : props.discussionId,
            commentId: props?.commentId,
            cjmId: props?.cjmIdStr,
            personaId: props?.personaIdStr,
        }
    })
});


const createPostActionDiscu = InitActionCreator({ baseUrl: "api/discussion/", method: "POST" }); // api actions type post
const createGetActionDiscu = InitActionCreator({ baseUrl: "api/discussion/", method: "GET" });
export const getMapDiscussions = (props) => createGetActionDiscu({
    type: 'GET_MAP_DISCUSSIONS', endPoint: constructUrl("getAll", {
        cjmId: props.cjmIdStr,
        personaId: props.personaIdStr,
    }),
});
export const getMapDiscussionsFn = async (props) => genericService({ ...props, action: getMapDiscussions });

export const createDiscussion = (props) => genericService({
    ...props, action: createPostActionDiscu({
        type: 'CREATE_DISCUSSION', endPoint: "create",
        data: {
            discussion: {
                cjmId : props.cjmId,
                personaId : props.personaId,
                objId : props.objId,
                objName : props.objName,
                prefixRelationships: props.prefixRelationships,
                relatedId : props.relatedId,
                relatedName : props.relatedName,
                ownerId : props.ownerId,
                stageId : props.stageId,
                swimlaneId : props.swimlaneId,

            },
            channelId : props.channelId || EMPTY_GUID,
        }
    })
});

export const updateStatusDiscussion = (props) => genericService({
    ...props, action: createPostActionDiscu({
        type: 'UPDATE_STATUS_DISCUSSION', endPoint: "updateStatus",
        data: {
            discussionId: props.discussionId,
            isResolved: props.isResolved,
            cjmId : props.cjmId,
            personaId : props.personaId,
        }
    })
});
export const deleteDiscussion = (props) => genericService({
    ...props, action: createPostActionDiscu({
        type: 'DELETE_DISCUSSION', endPoint: "delete",
        data: {
            discussionId: props.discussionId,
            cjmId : props.cjmId,
            personaId : props.personaId,
        }
    })
});
export  const updateToggleComment = (props) => genericService({
    ...props, action: createPostMapAction({
        type: 'UPDATE_TOGGLE_COMMENT', endPoint: "showComments",
        data: {
          show: props.show,
          cjmId : props.cjmId,
        }
    })
});
export const updateToggleCommentResolved = (props) => genericService({
    ...props, action: createPostMapAction({
        type: 'UPDATE_TOGGLE_COMMENT_RESOLVED', endPoint: "showResolvedComments",
        data: {
          show: props.show,
          cjmId : props.cjmId,
        }
    })
});